const Rating  = [
    2,
    2.5,
    3,
    3.5,
    4,
    4.5,
    5
]
export default Rating;